<div #formEl class="mat-typography mat-body component-container">
  <form [formGroup]="sbcSearchForm">

    <div>

      <div class="control-container">
        <mat-form-field appearance="outline">
          <mat-label>Select Year</mat-label>
          <mat-select formControlName="year" (selectionChange)="onFieldChange()">
            @for (year of years; track year) {
              <mat-option [value]="year">
                {{year}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <div class="control-container">
        <mat-form-field appearance="outline">
          <mat-label>Select Region</mat-label>
          <mat-select formControlName="region" (selectionChange)="onRegionChange()">
            @for (region of regions; track region) {
              <mat-option [value]="region.value">
                {{region.name}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

    </div>

    @if (showFilters) {
      <div>
        <div>
          <p class="heading">Search By</p>
          <mat-radio-group formControlName="searchMethod" (change)="onChangeSearchMethod($event)" [(ngModel)]="selectedSearchMethod">
            <mat-radio-button value="groupNumber">Group Number</mat-radio-button>
            <mat-radio-button value="zipCode">Zip Code</mat-radio-button>
          </mat-radio-group>
        </div>
        @if (selectedSearchMethod === 'groupNumber') {
          <div>
            <mat-form-field appearance="outline">
              <input matInput (input)="onGroupNumberChange($event.target.value)" type="textbox" placeholder="Group Number" formControlName="groupNumber">
            </mat-form-field>
            <div>
              <button (click)="!isDisabled && submitGroupNumberSearch()" class="search-button" mat-raised-button color="primary" type="submit">Search</button>
            </div>
          </div>
        }
        @if (selectedSearchMethod === 'zipCode') {
          <div>
            <mat-form-field appearance="outline">
              <input matInput [(ngModel)]="zipVal" type="textbox" placeholder="Zip Code" formControlName="zipCode" minLength="5" maxlength="5">
              @if (sbcSearchForm.controls.zipCode.hasError('mismatchedZip')) {
                <mat-error>Please enter a zipcode within the selected region</mat-error>
              }
            </mat-form-field>
            <!-- Single County -->
            @if (isSingleCounty) {
              <mat-form-field appearance="outline">
                <mat-label>County</mat-label>
                <input matInput required readonly formControlName="countySingle" [value]="singleCounty ? singleCounty.county : ''">
              </mat-form-field>
            }
            <!-- Multiple Counties -->
            @if (!isSingleCounty) {
              <mat-form-field appearance="outline">
                <mat-label>Select County</mat-label>
                <mat-select formControlName="county" (selectionChange)="onChangeMultipleCounties($event)" class="multiple-counties-select">
                  @for (countyInfo of counties; track countyInfo) {
                    <mat-option [value]="countyInfo">
                      {{countyInfo.county}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }
            <mat-form-field appearance="outline">
              <mat-label>Select Effective Date</mat-label>
              <mat-select formControlName="effectiveDate" (selectionChange)="onFieldChange()">
                @for (month of months; track month) {
                  <mat-option [value]="month.value">
                    {{month.name}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <div>
              <button (click)="!isDisabled && submitZipCodeSearch()" class="search-button" mat-raised-button color="primary" type="submit">Search</button>
            </div>
          </div>
        }
      </div>
    }

  </form>


  <!-- Document Table -->
  <div [hidden]="!dataSource" class="table-container">

    <!-- File Search -->
    <form [formGroup]="textFilterForm">

      <mat-form-field appearance="outline" class="search-input">

        <mat-label>Search for a file</mat-label>
        <input type="text" matInput [formControlName]="'fileSearch'" />

        @if (textFilterFormValues.fileSearch?.length < textFilterFormMinimumReqs.length) {
          <mat-error>
            You must enter at least {{textFilterFormMinimumReqs}} characters
          </mat-error>
        }

      </mat-form-field>
    </form>

    <mat-table mat-table matSort class="mat-elevation-z6" [dataSource]="dataSource">

      <ng-container matColumnDef="productName">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          <span>Document</span>
        </mat-header-cell>
        <mat-cell *matCellDef="let document">
          <a href="javascript:void(0);" class="no-text-decor" (click)="downloadDocument(document)">
            <span class="bold-title">
              {{document.productName}}
            </span>
          </a>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="download">
        <mat-header-cell *matHeaderCellDef>
          <span>Download</span>
        </mat-header-cell>
        <mat-cell *matCellDef="let document">
          <a href="javascript:void(0);" class="light-padding" (click)="downloadDocument(document)">
            <span class="material-symbols-outlined">save_alt</span>
          </a>
        </mat-cell>
      </ng-container>

      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="9999">
          No data matching the filter
        </td>
      </tr>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

    </mat-table>

    <!-- Paginator -->
    <mat-paginator #SmallGroupSbcPaginator [length]="dataSource && dataSource.data && dataSource.data.length" [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
  </div>
</div>
